/* MG Klaviyo newsletter wiring (MG-custom, single source = Klaviyo).
   The footer + popup newsletter forms are native Shopify customer forms. We INTERCEPT
   their submit (preventDefault + stopPropagation, capture phase on document) so that:
     - NO Shopify customer is created and NO Shopify double-opt-in mail is sent
     - the page does NOT navigate (the native submit previously aborted our keepalive fetch)
   We then subscribe directly to the market/language Klaviyo list via the public Client
   Subscriptions API (public key only, no private key) and render our own feedback.
   Config + texts: snippets/mg-klaviyo-newsletter.liquid. The DE list is double-opt-in
   (Klaviyo sends the confirmation mail); all other markets are single opt-in. */
(function () {
  'use strict';
  var cfg = window.mgKlaviyo || {};
  if (!cfg.publicKey) return;
  var texts = cfg.texts || {};

  // A native Shopify newsletter form is a customer form carrying the "newsletter" tag.
  function isNewsletterForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var tag = form.querySelector('input[name="contact[tags]"]');
    return !!(tag && /newsletter/i.test(tag.value || ''));
  }

  function subscribe(email) {
    var listId = cfg.listId;
    if (!listId) return Promise.resolve(false); // no Klaviyo list for this market (e.g. International / EN root)
    var payload = { data: { type: 'subscription', attributes: {
      custom_source: 'Newsletter',
      profile: { data: { type: 'profile', attributes: {
        email: email,
        properties: { language: cfg.lang, market: cfg.market, source: 'Newsletter' },
        // Consent block: SUBSCRIBED -> single-opt-in lists subscribe immediately ("Subscribed to Email
        // Marketing" fires -> Welcome flow). The DE list is double-opt-in: Klaviyo honours the list
        // setting and sends its own confirmation instead. Requires revision >= 2026-04-15.
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      } } }
    }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.status >= 200 && r.status < 300; }).catch(function () { return false; });
  }

  // Custom event that triggers the Welcome flow. Klaviyo does NOT fire flows on the "Subscribed to Email
  // Marketing" system metric, so the Welcome flow listens on this custom event instead (reliable, like Revieve).
  // Sent ONLY for single-opt-in markets; DE is double-opt-in and gets its Welcome via the list confirmation.
  // Public key only (client events API). Profile language drives the flow's language split.
  function sendSignupEvent(email) {
    if (cfg.doi) return;
    var payload = { data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Newsletter Signup' } } },
      properties: { language: cfg.lang, market: cfg.market, source: 'Newsletter' },
      profile: { data: { type: 'profile', attributes: { email: email } } }
    } } };
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.publicKey), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        keepalive: true, body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  // Render our own feedback in the form (the native Sleek success/navigation is suppressed). No red (MG brand).
  function showFeedback(form, ok) {
    var note = form.querySelector('.mg-newsletter__note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'mg-newsletter__note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      note.style.margin = '0.8rem 0 0';
      note.style.fontSize = '1.3rem';
      note.style.lineHeight = '1.4';
      form.appendChild(note);
    }
    if (ok) {
      // MG-PATCH 2026-07-03 (Trello RFfKY6LY): the success message carries the WELCOME
      // code, code itself bold — built via DOM nodes.
      // MG-PATCH 2026-08-19 (REQ0093119): never on a double-opt-in list. Showing the code
      // before the address is confirmed removes the incentive to click the confirmation
      // link; Klaviyo delivers it in the DOI confirmation mail instead. Today this is /de/
      // only (V3rEbF is the sole DOI list) — /de-ch/ and all other locales keep it inline.
      note.textContent = texts.ok || 'Thank you!';
      if (!cfg.doi) {
        note.textContent += ' ' + (texts.codeLabel || 'Your welcome code is') + ' ';
        var codeEl = document.createElement('strong');
        codeEl.textContent = texts.code || 'WELCOME';
        note.appendChild(codeEl);
      }
      var wrap = form.querySelector('.newsletter-form__field-wrapper');
      if (wrap) wrap.style.display = 'none'; // hide the input row on success
    } else {
      note.textContent = texts.error || 'Something went wrong. Please try again later.';
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isNewsletterForm(form)) return;
    // Klaviyo is the single source: cancel the native Shopify submit entirely (no Shopify customer,
    // no Shopify opt-in mail, no navigation). stopPropagation keeps the Sleek newsletter-form
    // component from also handling it; other document listeners (analytics) still run.
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('input[type="email"], input[name="contact[email]"]');
    if (!input || !input.value) return;
    if (input.validity && !input.validity.valid) { if (input.reportValidity) input.reportValidity(); return; }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    var email = input.value.trim();
    subscribe(email).then(function (ok) {
      if (btn) btn.disabled = false;
      showFeedback(form, ok);
      if (ok) sendSignupEvent(email); // fires the Welcome flow (single-opt-in markets)
    });
  }, true); // capture phase on document = runs before the Sleek newsletter-form component
})();
